/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiGetBindHistories } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'bindRecordModal',
  setup(__props, {
    expose
  }) {
    const playId = ref();
    const columns = [{
      label: '绑定时间',
      prop: 'created_at',
      slot: 'created_at'
    }, {
      label: '操作',
      prop: 'operation',
      slot: 'operation'
    }, {
      label: '绑定GS',
      prop: 'name'
    }, {
      label: '操作人',
      prop: 'updated_user'
    }];
    const dialogVisible = ref(false);
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiGetBindHistories({
        id: playId.value,
        page: current.value,
        page_size: pageSize.value
      });
      tableLoading.value = false;
      if (res.code === 0) {
        total.value = res.data.total;
        tableData.value = res.data.list;
      }
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total
    } = UseTable(getTableData);
    const show = payload => {
      dialogVisible.value = true;
      if (payload.data) {
        playId.value = payload.data.id;
        getTableData();
      }
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = __unplugin_components_0;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "绑定记录",
        width: "800px",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          total: _unref(total),
          pagination: ""
        }, {
          created_at: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.created_at)), 1)]),
          operation: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(scope.row.operation === 1 ? '绑定' : scope.row.operation === 2 ? '换绑' : '解绑'), 1)]),
          _: 1
        }, 8, ["data", "loading", "total"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});